import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { z } from 'zod';

import { useApi } from '@/lib/api-context';

// Cierre de la etapa de capacitación por Calidad (G2-C): POST
// /api/v1/quality/documents/:entryId/training-stage/close con motivo, cuando el LMS no
// reporta el documento. Refresca la etapa, la ficha, el editor y la lista.

const resultSchema = z.object({
  success: z.literal(true),
  data: z.object({ closedAt: z.string() }),
});
export type CloseTrainingResult = z.infer<typeof resultSchema>['data'];

export interface CloseTrainingVars {
  entryId: string;
  reason: string;
}

export function useCloseTraining(): UseMutationResult<
  CloseTrainingResult,
  Error,
  CloseTrainingVars
> {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ entryId, reason }: CloseTrainingVars) => {
      const raw = await api.post<unknown>(
        `/api/v1/quality/documents/${entryId}/training-stage/close`,
        { reason },
      );
      return resultSchema.parse(raw).data;
    },
    onSuccess: () => {
      for (const key of ['training-stage', 'dossier', 'flow-capabilities', 'master-list']) {
        void qc.invalidateQueries({ queryKey: [key] });
      }
    },
  });
}
